import React from 'react';
import { Tabs } from 'antd';
import TtLocationConfigPage from './tt-location-config/TtLocationConfigPage';
import TtPresortConfigPage from './tt-presort-config/TtPresortConfigPage';

/**
 * 分拣配置容器页：Tab 切换 位置配置(tt_location_config) / 预分拣配置(tt_presort_config)。
 */
const TtSortingConfigPage: React.FC = () => (
  <div className="bg-white rounded-lg shadow-sm px-3 pb-3 pt-0">
    <Tabs
      defaultActiveKey="location"
      items={[
        { key: 'location', label: '基础配置', children: <TtLocationConfigPage /> },
        { key: 'presort', label: '预分拣配置', children: <TtPresortConfigPage /> },
      ]}
    />
  </div>
);

export default TtSortingConfigPage;
